import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
      color: "black", 
      height: "5px",
    },
    righticon: {
          color: "white", 
        },
  }));

const Subheader = () => {
    const classes = useStyles();
    return(
        <div className={classes.root}>
            <br />
        </div>
    )
}
export default Subheader;